<template>
  <div id="sportsDetail_scheduleDetail">
    <div class="shedule_date">
      <span class="phaseTab">
        <span
          class="phaseItem"
          v-for="phaseItem in phaseArr"
          :key="phaseItem.phaseCode"
          v-text="phaseItem.phaseName"
          :class="phaseItem.act ? 'act' : ''"
          @click="clickPhaseItem(phaseItem)"
        ></span>
      </span>
      <SWIPER_SCHEDULE_DATE
        v-if="currMatch && swiper_datas && swiper_datas.length > 0"
        :currMatch="currMatch"
        :datas="swiper_datas"
        @updateCurrMatch="updateCurrMatchHandle"
      ></SWIPER_SCHEDULE_DATE>
    </div>
    <SCHEDULEDETAIL_BASEINFOR
      :CSMeetScheduleInfo="currMatchDetailInfor"
    ></SCHEDULEDETAIL_BASEINFOR>
    <div class="stringSocreExplain">
      <span
        class="noteInfo_item"
        v-for="(item, index) in currMatchDetailInfor.annotation"
        :key="index"
        v-text="`${item.name}：${item.explain}`"
      ></span>
    </div>
    <div class="matchDetail_tab">
      <span
        class="matchResultTabItem"
        v-for="item in matchResultTabArr"
        :key="item.key"
        :class="item.act ? 'act' : ''"
        v-text="item.name"
        @click="clickTab(item)"
      ></span>
    </div>
    <div class="matchDetailDataContainer">
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :isRefresh="isRefresh"
        :refreshTime="refreshTime"
        :isShowAnalysisFlag="isShowAnalysisFlag"
        :dataBattleReportInfor="dataBattleReportInfor"
        :localDataProp="localDataProp"
        :startListProp="startListProp"
        :curTimeZoneItem="curTimeZoneItem"
      ></router-view>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import {
  https_sportsEvent_schedule,
  https_getPhaseSchedule,
  https_scheduleDetail_matchDetailData,
  https_scheduleDetail_dataBattleReport,
} from '@api/platfrom_compreSportsMeet_api'
import { https_package_getTemplateTypes } from '@api/platfrom_base_api'

import SWIPER_SCHEDULE_DATE from '@components/platfromBase/compreSportsMeet/SWIPER_SCHEDULE_DATE.vue'
import SCHEDULEDETAIL_BASEINFOR from '@components/platfromBase/compreSportsMeet/scheduleDetail_baseInfor.vue'
// import MockData_Mode from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/mock_mode/mode_11.js'
export default {
  name: 'sportsDetail_scheduleDetail',
  mixins: [cup_base_data_mixin],
  components: { SWIPER_SCHEDULE_DATE, SCHEDULEDETAIL_BASEINFOR },
  props: {
    // currSportsDetail: {
    //   type: Object,
    //   default: () => ({}),
    // },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    // isRefresh: {
    //   type: Boolean,
    //   default: false,
    // },
    // refreshTime: {
    //   type: Number,
    //   default: 15 * 1000,
    // },
    // pageJumpParams: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   },
    // },
    bigSportsList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被验证前调用
    // 不能获取组件实例 `this` ！
    // 因为当守卫执行时，组件实例还没被创建！
    console.debug('beforeRouteEnter', from.name, to.name)
    // console.debug('route:', this.$route)
    const currTabPathName = to.name

    next((vm) => {
      vm.matchResultTabArr.forEach((item) => {
        if (item.pathName === currTabPathName) {
          item.act = true
        } else {
          item.act = false
        }
      })
    })
  },
  watch: {
    currSportsDetail: {
      handler(newVal, oldVal) {
        console.debug('scheduleDetail 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.cancelRefreshSetTimeout()
          //   if (newVal.eventId != oldVal.eventId) {
          //     this.currMatch = ''
          //     this.init()
          //   } else
          if (newVal.matchId != oldVal.matchId) {
            // 重新计算需要绘画的视图
            this.eventCompModeObj = null
            this.localDataProp = {
              type: 'localData',
              datas: null,
              isHasData: true,
              eventCompMode: '',
              competitorType: '',
              eventCompModeObj: null,
              isCombatFlag: false,
              groupIndexStr: '-1',
            }
            this.startListProp = {
              type: 'startList',
              datas: null,
              isHasData: true,
              eventCompMode: '',
              competitorType: '',
              isCombatFlag: false,
              groupIndexStr: '-1',
            }
          }
        }
      },
      //   immediate: true,
      deep: true,
    },
    $route(to, from) {
      // 监听路由变化，矫正 tab 选中状态
      if (this.matchResultTabArr && this.matchResultTabArr.length > 0) {
        console.debug('$route:', from.name, to.name)
        this.matchResultTabArr.forEach((tabItem) => {
          if (`${tabItem.pathName}_${this.currCid}` === to.name) {
            tabItem.act = true
          } else {
            tabItem.act = false
          }
        })
      }
    },
  },
  data() {
    return {
      refreshTime: 15 * 1000,
      isRefresh: false,
      currSportsDetail: {
        sportsId: null,
        sportsName: null,
        eventId: null,
        eventName: null,
        matchId: null,
      },
      phaseArr: [],
      currMatch: '', //首次加载初始化日期
      swiper_datas: [],
      matchStatusColorArr: [
        {
          colorClass: 'unstart',
          key: ['GETTING_READY', 'SCHEDULED'],
          name: ['已就绪', '按日程计划'],
        },
        {
          colorClass: 'playing',
          key: ['RUNNING', 'SCHEDULED_BREAK'],
          name: ['比赛中', '中场休息'],
        },
        {
          colorClass: 'finished',
          key: ['FINISHED', 'UNSCHEDULED'],
          name: ['已结束', '未安排'],
        },
        {
          colorClass: 'other',
          key: ['CANCELLED', 'DELAYED', 'INTERRUPTED', 'RESCHEDULED'],
          name: ['已取消', '延误', '中断', '推迟', '改期'],
        },
      ],
      resultTypeArr: [
        {
          name: '中间成绩',
          key: 'INTERMEDIATE',
          className: '',
        },
        {
          name: '实时',
          key: 'LIVE',
          className: '',
        },
        {
          name: '官方',
          key: 'OFFICIAL',
          className: '',
        },
        {
          name: '部分成绩',
          key: 'PARTIAL',
          className: '',
        },
        {
          name: '仲裁中',
          key: 'PROTESTED',
          className: '',
        },
        {
          name: '秩序单',
          key: 'START_LIST',
          className: '',
        },
        {
          name: '未确认',
          key: 'UNCONFIRMED',
          className: '',
        },
        {
          name: '非官方',
          key: 'UNOFFICIAL',
          className: '',
        },
      ],
      currResultType: null,
      currMatchDetailInfor: {},
      matchResultTabArr_base: [
        {
          key: 'startList',
          name: '出场名单',
          pathName: 'CSMeetSportDetailScheduleDetailStartList',
          value: '',
          act: true,
        },
        {
          key: 'localData',
          name: '本场数据',
          pathName: 'CSMeetSportDetailScheduleDetailLocalData',
          value: '',
          act: false,
        },
        {
          key: 'dataAnalysis',
          name: '本场数据分析',
          value: '',
          act: false,
          pathName: 'CSMeetSportDetailScheduleDetailDataAnalysis',
        },
        {
          key: 'dataBattleReport',
          name: '数据战报',
          value: '',
          act: false,
          pathName: 'CSMeetSportDetailScheduleDetailDataBattleReport',
        },
      ],
      matchResultTabArr: [],
      localDataProp: {
        type: 'localData',
        datas: null,
        isHasData: true,
        eventCompMode: '',
        competitorType: '',
        eventCompModeObj: null,
        isCombatFlag: false,
        groupIndexStr: '-1',
      },
      startListProp: {
        type: 'startList',
        datas: null,
        isHasData: true,
        eventCompMode: '',
        competitorType: '',
        eventCompModeObj: null,
        isCombatFlag: false,
        groupIndexStr: '-1',
      },
      eventCompModeObj: null,
      isShowAnalysisFlag: true,
      dataBattleReportInfor: null,
      refreshId: null,
      groupIndex: '-1',
    }
  },
  created() {
    console.debug(
      'this.$route:',
      this.currSid,
      this.currSportsDetail,
      this.$route
    )
    const query = this.$route.query
    const params = this.$route.params
    this.currMatch = query.mid ? query.mid : ''
    if (query.isRefresh) {
      this.isRefresh = query.isRefresh
    }
    if (query.refreshTime) {
      this.refreshTime = query.refreshTime
    }
    if (params.groupIndex) {
      this.groupIndex = params.groupIndex
    }
    this.currSportsDetail = {
      sportsId: query.sportsId,
      sportsName: null,
      eventId: query.eventId,
      eventName: null,
      matchId: query.mid,
    }
    this.pageJumpParams = [query, this.currSportsDetail]
    this.updateCurrSportsDetailHanlder(query.eventId, this.currMatch)
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  beforeDestroy() {
    this.cancelRefreshSetTimeout()
  },
  methods: {
    async init() {
      console.debug('this.init:', this.currMatch, this.groupIndex)
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getScheduleMatchList()
      await this.getMatchDetailData()
      await this.getTemplateTypes()
      await this.getDataBattleReport()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    refreshSetTimeoutMatchData() {
      //开启定时
      this.cancelRefreshSetTimeout()
      // 开发时，实时刷新功能先关闭
      this.refreshId = setTimeout(() => {
        this.getMatchDetailData()
      }, this.refreshTime)
    },
    cancelRefreshSetTimeout() {
      //取消定时
      if (this.refreshId) {
        clearTimeout(this.refreshId)
      }
    },
    clickPhaseItem(actItem) {
      this.phaseArr.forEach((item) => {
        if (item.phaseCode === actItem.phaseCode) {
          item.act = true
          this.setSwiperData(item.phaseMatchList)
        } else {
          item.act = false
        }
      })
    },
    clickTab(tab) {
      let isPageJumpFlag = false
      console.debug(' this.matchResultTabArr:', this.matchResultTabArr)
      this.matchResultTabArr.forEach((item) => {
        if (item.key === tab.key) {
          if (
            !item.act ||
            `${tab.pathName}_${this.currCid}` !== this.$route.name
          ) {
            isPageJumpFlag = true
          }
          item.act = true
        } else {
          item.act = false
        }
      })
      if (isPageJumpFlag) {
        console.debug('this.pageJumpParams:', this.pageJumpParams, tab)
        const [query, params] = this.pageJumpParams
        const pathName =
          typeof tab.pathName === 'string' ? tab.pathName : tab.pathName[0] //数组的话默认返回第一个，第一个是父级
        this.pageReplaceJump(
          this.$router,
          `${pathName}_${this.currCid}`,
          query,
          params
        )
      }
    },
    updateCurrSportsDetailHanlder(eventId, matchId) {
      let [query, params] = this.pageJumpParams
      //   let isChangeQueryFlag = false
      console.debug('updateCurrSportsDetailHanlder:', params, query)
      let newQuery = JSON.parse(JSON.stringify(query))
      let newParams = JSON.parse(JSON.stringify(params))
      if (query.eventId && query.eventId !== eventId) {
        newParams.eventId = eventId
        newQuery.eventId = eventId
      }
      if (query.mid && query.mid !== matchId) {
        newParams.matchId = matchId
        newQuery.mid = matchId
        // let currSportsDetail = this.currSportsDetail
        // currSportsDetail.matchId = matchId

        console.debug('updateCurrSportsDetailHanlder:', newQuery)
        this.currSportsDetail = newParams
        this.pageJumpParams = [newQuery, newParams]
        this.$router.replace({
          query: newQuery,
          params: newParams,
        })
      }
    },
    async updateCurrMatchHandle(item) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.currMatch = item.matchId
      this.updateCurrSportsDetailHanlder(item.eventId, item.matchId)
      await this.getMatchDetailData()
      await this.getDataBattleReport()
      console.debug('加载赛果数据')
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    renderEventCompModeHanlde(resData = {}) {
      console.debug(
        'renderEventCompModeHanlde:',
        resData,
        this.eventCompModeObj
      )
      let currBigSportsObj = null
      if (this.bigSportsList && resData.disciplineCode) {
        this.bigSportsList
        this.bigSportsList.forEach((item) => {
          if (item.id === resData.disciplineCode) {
            currBigSportsObj = item
          }
        })
      }

      // 处理特殊的大项，更换 matchResultTabArr （体操项目）
      let matchResultTabArr = null
      console.debug('currBigSportsObj:', currBigSportsObj)
      if (
        currBigSportsObj &&
        currBigSportsObj.routePageArr &&
        currBigSportsObj.routePageArr.length > 0
      ) {
        currBigSportsObj.routePageArr.forEach((routePage, routerIndex) => {
          if (
            routePage.phaseIdArr &&
            routePage.phaseIdArr.includes(resData.scheduleInfo.phaseCode)
          ) {
            matchResultTabArr = routePage.tabArr
          } else if (
            routePage.eventIdArr &&
            routePage.eventIdArr.includes(this.currSportsDetail.eventId)
          ) {
            if (routePage.sportsType) {
              // 除了小项id，还要根据比赛是否对抗来判断【射箭男子个人|女子个人 排名赛】
              const isCombatFlag = !Boolean(
                this.sportsTypeArr.indexOf(routePage.sportsType)
              )
              console.debug('isCombatFlag:', isCombatFlag)
              if (isCombatFlag === resData.is_confrontational) {
                matchResultTabArr = routePage.tabArr
              }
            } else {
              // 不同赛季，相同大小项展示不同的赛果
              matchResultTabArr = routePage.tabArr
            }
          } else {
            if (
              routePage.customViewType &&
              resData.scheduleInfo &&
              resData.scheduleInfo.customViewType &&
              resData.scheduleInfo.customViewType === routePage.customViewType
            ) {
              matchResultTabArr = routePage.tabArr
            } else if (routePage.localDataTitleArr) {
              // 游泳 分组预赛|半决赛 都有会分组的情况，去掉分组的比赛，只显示一个比赛
              routePage.localDataTitleArr.forEach((titleName) => {
                if (resData.title.indexOf(titleName) > -1) {
                  matchResultTabArr = routePage.tabArr
                }
              })
            }
          }
          if (
            routerIndex === currBigSportsObj.routePageArr.length - 1 &&
            !matchResultTabArr
          ) {
            matchResultTabArr = routePage.tabArr
          }
        })
        // this.currMatchResultTab_sportsId = currBigSportsObj.id //体操
      } else {
        matchResultTabArr = this.matchResultTabArr_base
      }

      let currTab_key = null
      let sameKeyFlag = false
      let curTabIndex = 0
      console.debug(' this.matchResultTabArr:', this.matchResultTabArr)
      if (this.matchResultTabArr.length > 0) {
        // 不是刷新时，走这里，因为this.matchResultTabArr有值
        this.matchResultTabArr.forEach((item, itemIndex) => {
          if (item.act) {
            currTab_key = item.key
            curTabIndex = itemIndex
          }
        })
      } else if (matchResultTabArr.length > 0) {
        // 是刷新走这里，因为this.matchResultTabArr没值，但matchResultTabArr应该有值
        const pathName = this.$route.name
        matchResultTabArr.forEach((item, itemIndex) => {
          if (pathName === `${item.pathName}_${this.currCid}`) {
            currTab_key = item.key
            sameKeyFlag = true
            item.act = true
            curTabIndex = itemIndex
          } else {
            item.act = false
          }
        })
      } else {
        // 因这里面不能切换大小项，一旦进入赛果 matchResultTabArr 是固定的，固定的所以刷新的时候比如会找相同的tab,出发切换比赛也会引起 matchResultTabArr 的变化，所以不需要走这个逻辑，
        console.error('因为切换比赛，导致matchResultTabArr发生变化')
        // 以防万一，这里可以设置默认为0
        curTabIndex = 0
        // if (!currTab_key) {
        //   curTabIndex = 0 //刷新页面重置到0
        // } else if (matchResultTabArr.length === 2) {
        //   curTabIndex = 0 //跳水 混合团体 tab只有2个【本场数据，数据分析】，因此没找到回到索引0
        // } else {
        //   curTabIndex = 1
        // }
      }
      console.debug(
        'curTabIndex:',
        curTabIndex,
        currTab_key,
        sameKeyFlag,
        matchResultTabArr,
        this.pageJumpParams
      )

      this.matchResultTabArr = JSON.parse(JSON.stringify(matchResultTabArr))
      this.clickTab(matchResultTabArr[curTabIndex])
      console.debug('matchResultTabArr:', matchResultTabArr)

      // 根据对抗和非对抗来设置 startList 和 localData 的视图
      if (currBigSportsObj) {
        let ind = 0
        if (resData.is_confrontational) {
          // 对抗类
          ind = 0
        } else {
          // 非对抗类
          ind = 1
        }
        console.debug(
          ind,
          resData.competitorType,
          currBigSportsObj,
          this.sportsTypeArr[ind],
          currBigSportsObj[this.sportsTypeArr[ind]]
        )
        const eventCompModeArr =
          currBigSportsObj[this.sportsTypeArr[ind]][resData.competitorType]

        console.debug('eventCompModeArr:', eventCompModeArr)
        if (eventCompModeArr && eventCompModeArr.length === 1) {
          this.eventCompModeObj = eventCompModeArr[0]
        } else {
          // 存在多个视图时，需要过滤
          for (let i = 0; i < eventCompModeArr.length; i++) {
            const modeItem = eventCompModeArr[i]
            console.debug('eventCompModeArr:', modeItem)
            if (
              modeItem.customViewType &&
              resData.scheduleInfo &&
              resData.scheduleInfo.customViewType &&
              resData.scheduleInfo.customViewType === modeItem.customViewType
            ) {
              this.eventCompModeObj = modeItem
              break
            } else if (
              modeItem.specialEventArr &&
              modeItem.specialEventArr.includes(resData.eventCode)
            ) {
              this.eventCompModeObj = modeItem
              break
            }
            if (!modeItem.specialEventArr) {
              // 上面的都没取到，则取最后一个默认视图
              this.eventCompModeObj = modeItem
            }
          }
        }
      }
      console.debug('this.eventCompModeObj 1:', this.eventCompModeObj)
      if (resData && resData.resultInfo) {
        // 本场数据  田径 【男子十项全能 |女子七项全能】需要通过 localDataTitleArr 判断
        let eventCompMode = this.lockEventCompMode(
          this.eventCompModeObj,
          'localData',
          resData
        )
        console.debug('eventCompMode 1:', eventCompMode)
        this.localDataProp = {
          type: 'localData',
          datas: resData.resultInfo,
          isHasData: true,
          competitorType: resData.competitorType,
          eventCompMode,
          eventCompModeObj: this.eventCompModeObj,
          isCombatFlag: resData.is_confrontational,
          groupIndexStr: this.groupIndex,
        }
      } else {
        if (!this.localDataProp.datas) {
          // 初次赋值，需要定下视图mode; 没有数据时一直为null；一旦有了数据如果下次更新数据时接口没有给数据，则舍弃这次数据，保留上一次的数据

          // 本场数据  田径 【男子十项全能 |女子七项全能】需要通过 localDataTitleArr 判断
          let eventCompMode = this.lockEventCompMode(
            this.eventCompModeObj,
            'localData',
            resData
          )
          this.localDataProp = {
            type: 'localData',
            datas: null,
            isHasData: false,
            competitorType: resData.competitorType,
            eventCompMode,
            eventCompModeObj: this.eventCompModeObj,
            isCombatFlag: resData.is_confrontational,
            groupIndexStr: this.groupIndex,
          }
        }
      }

      if (resData && resData.startList) {
        // 出场名单 射击 【25米手枪速射 |】
        console.debug('startListTitleArr', this.eventCompModeObj)
        let eventCompMode = this.lockEventCompMode(
          this.eventCompModeObj,
          'startList',
          resData
        )

        this.startListProp = {
          type: 'startList',
          datas: resData.startList,
          isHasData: true,
          competitorType: (this.eventCompModeObj && this.eventCompModeObj.customViewType)
            ? `${resData.competitorType}-${this.eventCompModeObj.customViewType}`
            : resData.competitorType, //[A,D,T,A-GP(出场名单 A 常规分组),T-GP]
          eventCompMode,
          eventCompModeObj: this.eventCompModeObj,
          isCombatFlag: resData.is_confrontational,
          groupIndexStr: this.groupIndex,
        }
      } else {
        if (!this.startListProp.datas) {
          // 初次赋值，需要定下视图mode; 没有数据时一直为null；一旦有了数据如果下次更新数据时接口没有给数据，则舍弃这次数据，保留上一次的数据

          // 出场名单 射击 【25米手枪速射 |】
          console.debug('startListTitleArr', this.eventCompModeObj)
          let eventCompMode = this.lockEventCompMode(
            this.eventCompModeObj,
            'startList',
            resData
          )

          this.startListProp = {
            type: 'startList',
            datas: null,
            isHasData: false,
            competitorType: (this.eventCompModeObj && this.eventCompModeObj.customViewType)
              ? `${resData.competitorType}-${this.eventCompModeObj.customViewType}`
              : resData.competitorType,
            eventCompMode,
            eventCompModeObj: this.eventCompModeObj,
            isCombatFlag: resData.is_confrontational,
            groupIndexStr: this.groupIndex,
          }
        }
      }
    },
    lockEventCompMode(eventCompModeObj, tabType, resData) {
      const tabKeyArr = ['startList', 'localData']
      let eventCompMode =
        eventCompModeObj && eventCompModeObj[`${tabType}`]
          ? eventCompModeObj[`${tabType}`]
          : ''
      if (eventCompModeObj && eventCompModeObj[`${tabType}TitleArr`]) {
        let flag = false
        eventCompModeObj[`${tabType}TitleArr`].forEach((titleItem) => {
          if (resData.title.indexOf(titleItem) > -1) {
            flag = true
          }
        })
        if (!flag) {
          // 如果不在 `${tabType}TitleArr` 数组中，则取视图默认是视图
          eventCompMode =
            eventCompModeObj.defaultEventCompMode[tabKeyArr.indexOf(tabType)]
        }
      }
      console.debug('eventCompMode:', eventCompMode)
      return eventCompMode
    },
    async getDataBattleReport() {
      // 获取数据战报
      await https_scheduleDetail_dataBattleReport(
        this.axiosBaseUrl,
        this.$axios,
        {
          sid: this.currSid,
          unitCode: this.currMatch,
        }
      )
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.dataBattleReportInfor = {
                isHasData: true,
                dataArr: res.data,
              }
            } else {
              this.dataBattleReportInfor = {
                isHasData: false,
                dataArr: res.data,
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getTemplateTypes() {
      await https_package_getTemplateTypes(this.axiosBaseUrl, this.$axios, {
        competitionId: this.currCid,
        seasonId: this.currSid,
        analysisType: '2',
        disciplineId: this.currSportsDetail.sportsId
          ? this.currSportsDetail.sportsId
          : '',
        eventId: this.currSportsDetail.eventId
          ? this.currSportsDetail.eventId
          : '',
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data && res.data.length > 0) {
              // this.themeTemplateType =
              //   res.data[0] && res.data[0].templateType
              //     ? res.data[0].templateType
              //     : null
              this.isShowAnalysisFlag = true
            } else {
              console.debug('暂无数据')
              // this.themeTemplateType = null
              this.isShowAnalysisFlag = false
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    setSwiperData(arr) {
      let matchList
      console.debug('setSwiperData:', arr)
      if (arr) {
        matchList = arr
      } else {
        matchList = []
      }
      this.matchList = JSON.parse(JSON.stringify(matchList))
      console.debug('setSwiperData:', matchList)
      if (matchList.length > 0) {
        let swiper_datas = []
        let dayArr = []
        matchList.forEach((matchItem) => {
          if (dayArr.length >= 5) {
            swiper_datas.push({
              dayArr,
            })
            dayArr = []
          }
          dayArr.push(matchItem)
        })
        if (dayArr.length > 0) {
          swiper_datas.push({
            dayArr,
          })
        }
        this.swiper_datas = JSON.parse(JSON.stringify(swiper_datas))
      }
    },
    async getScheduleMatchList() {
      await https_getPhaseSchedule(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
        disciplineCode: this.currSportsDetail.sportsId
          ? this.currSportsDetail.sportsId
          : '',
        eventCode: this.currSportsDetail.eventId
          ? this.currSportsDetail.eventId
          : '',
        scheduleCode: this.currMatch,
        timeZone: this.curTimeZoneItem.val, // 'beijing',
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            let actIndex = -1
            if (res.data) {
              this.phaseArr = res.data.phaseSchedule
                ? res.data.phaseSchedule.map((phaseItem, phaseIndex) => {
                    if (phaseItem.phaseCode === res.data.currentPhase) {
                      actIndex = phaseIndex
                    }
                    return {
                      act: actIndex === phaseIndex,
                      phaseCode: phaseItem.phaseCode,
                      phaseName: phaseItem.phaseName,
                      phaseMatchList: phaseItem.phaseSchedule.map(
                        (item, itemIndex) => {
                          let newItem = {}
                          newItem.matchTime = item.formatTime
                          newItem.matchName = `${item.disciplineName}·${item.scheduleName}`
                          newItem.isChina = item.cn
                          newItem.isGold = item.medalFlag === '1'
                          newItem.type = item.confrontation
                            ? this.sportsTypeArr[0]
                            : this.sportsTypeArr[1]
                          newItem.matchId = item.scheduleCode
                          newItem.venueName = item.venueName
                          newItem.matchStatus = item.scheduleStatus
                          newItem.sportsId = item.disciplineCode
                          newItem.sportsName = item.disciplineName
                          newItem.eventId = item.eventCode
                          newItem.eventName = item.eventName
                          newItem.scheduleName = item.scheduleName
                          newItem.formatDate = item.formatDate
                          newItem.formatTime = item.formatTime
                          newItem.unitType = item.unitType
                          newItem.competitor1Names = item.competitor1Names
                          newItem.competitor2Names = item.competitor2Names
                          newItem.competitor1Name = item.competitor1Name
                          newItem.competitor2Name = item.competitor2Name
                          newItem.competitorType = item.competitorType
                          newItem.medalist = item.medals
                            ? item.medals.map((player, index) => {
                                return {
                                  playerId: index + 1,
                                  mcompetitorType: player.mcompetitorType,
                                  playerName: player.competitorName,
                                  medalType: player.medalType,
                                  delegationName: player.organisationName,
                                  delegationLogo: player.organisationLogo,
                                }
                              })
                            : []

                          if (newItem.type === this.sportsTypeArr[0]) {
                            let homeName = '',
                              awayName = ''

                            homeName = item.competitor1Name
                              ? item.competitor1Name
                              : '待定'
                            awayName = item.competitor2Name
                              ? item.competitor2Name
                              : '待定'

                            newItem.homeName = homeName
                            newItem.awayName = awayName

                            newItem.homeScore = item.competitor1Result
                            newItem.awayScore = item.competitor2Result
                          }
                          newItem.homeLogo = item.organisation1Logo
                          newItem.awayLogo = item.organisation2Logo
                          if (!this.currMatch && itemIndex == 0) {
                            console.debug('this.currMatch:', this.currMatch)
                            this.currMatch = newItem.matchId
                            this.updateCurrSportsDetailHanlder(
                              newItem.eventId,
                              newItem.matchId
                            )
                          }
                          return newItem
                        }
                      ),
                    }
                  })
                : []
            } else {
              console.debug('暂无数据')
            }
            console.debug('this.phaseArr:', this.phaseArr, actIndex)
            this.setSwiperData(this.phaseArr[actIndex].phaseMatchList)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      // await https_sportsEvent_schedule(this.axiosBaseUrl, this.$axios, {
      //   sid: this.currSid,
      //   sportsId: this.currSportsDetail.sportsId
      //     ? this.currSportsDetail.sportsId
      //     : '',
      //   eventId: this.currSportsDetail.eventId
      //     ? this.currSportsDetail.eventId
      //     : '',
      //   timeZone: this.curTimeZoneItem.val, // 'beijing',
      // })
      //   .then((response) => {
      //     const res = response.data
      //     console.debug('response:', res)
      //     if (res.status === 0) {
      //       let matchList = []
      //       if (res.data) {
      //         matchList = res.data.map((item, itemIndex) => {
      //           let newItem = {}
      //           newItem.matchTime = item.formatTime
      //           newItem.matchName = `${item.disciplineName}·${item.scheduleName}`
      //           newItem.isChina = item.cn
      //           newItem.isGold = item.medalFlag === '1'
      //           newItem.type = item.confrontation
      //             ? this.sportsTypeArr[0]
      //             : this.sportsTypeArr[1]
      //           newItem.matchId = item.scheduleCode
      //           newItem.venueName = item.venueName
      //           newItem.matchStatus = item.scheduleStatus
      //           newItem.sportsId = item.disciplineCode
      //           newItem.sportsName = item.disciplineName
      //           newItem.eventId = item.eventCode
      //           newItem.eventName = item.eventName
      //           newItem.scheduleName = item.scheduleName
      //           newItem.formatDate = item.formatDate
      //           newItem.formatTime = item.formatTime
      //           newItem.competitor1Names = item.competitor1Names
      //           newItem.competitor2Names = item.competitor2Names
      //           newItem.competitorType = item.competitorType
      //           newItem.medalist = item.medals
      //             ? item.medals.map((player, index) => {
      //                 return {
      //                   playerId: index + 1,
      //                   mcompetitorType: player.mcompetitorType,
      //                   playerName: player.competitorName,
      //                   medalType: player.medalType,
      //                   delegationName: player.organisationName,
      //                   delegationLogo: player.organisationLogo,
      //                 }
      //               })
      //             : []

      //           if (newItem.type === this.sportsTypeArr[0]) {
      //             let homeName = '',
      //               awayName = ''

      //             homeName = item.competitor1Name
      //               ? item.competitor1Name
      //               : '待定'
      //             awayName = item.competitor2Name
      //               ? item.competitor2Name
      //               : '待定'

      //             newItem.homeName = homeName
      //             newItem.awayName = awayName

      //             newItem.homeScore = item.competitor1Result
      //             newItem.awayScore = item.competitor2Result
      //           }
      //           newItem.homeLogo = item.organisation1Logo
      //           newItem.awayLogo = item.organisation2Logo
      //           if (!this.currMatch && itemIndex == 0) {
      //             console.debug('this.currMatch:', this.currMatch)
      //             this.currMatch = newItem.matchId
      //             this.updateCurrSportsDetailHanlder(
      //               newItem.eventId,
      //               newItem.matchId
      //             )
      //           }
      //           return newItem
      //         })
      //       } else {
      //         console.debug('暂无数据')
      //       }
      //       this.matchList = JSON.parse(JSON.stringify(matchList))
      //       if (matchList.length > 0) {
      //         let swiper_datas = []
      //         let dayArr = []
      //         matchList.forEach((matchItem) => {
      //           if (dayArr.length >= 5) {
      //             swiper_datas.push({
      //               dayArr,
      //             })
      //             dayArr = []
      //           }
      //           dayArr.push(matchItem)
      //         })
      //         if (dayArr.length > 0) {
      //           swiper_datas.push({
      //             dayArr,
      //           })
      //         }
      //         this.swiper_datas = JSON.parse(JSON.stringify(swiper_datas))
      //       }
      //     } else {
      //       if (res.message) {
      //         // message：null，因此不弹出警示框（一般404 || 500的时候）；
      //         // message不为null的时候展示警示框；
      //         this.$message({
      //           showClose: true,
      //           message: res.message ? res.message : '服务器异常，请稍后再试',
      //           type: 'warning',
      //         })
      //       }
      //     }
      //   })
      //   .catch((err) => {
      //     console.debug(err)
      //   })
    },
    async getMatchDetailData() {
      await https_scheduleDetail_matchDetailData(
        this.axiosBaseUrl,
        this.$axios,
        {
          sid: this.currSid,
          sportsId: this.currSportsDetail.sportsId,
          mid: this.currMatch ? this.currMatch : '',
        }
      )
        .then((response) => {
          const res = response?.data || {}
          if (res.status === 0) {
            if (res.data) {
              // if (flag) {
              //   //测试数据变化
              //   this.renderEventCompModeHanlde({})
              // } else {
              //   this.renderEventCompModeHanlde(res.data)
              // }
              let currResultType = null
              this.resultTypeArr.forEach((typeItem) => {
                if (typeItem.key === res.data.result_status) {
                  currResultType = typeItem
                }
              })
              // this.currResultType = currResultType

              this.renderEventCompModeHanlde(res.data)

              const item = res.data.scheduleInfo
              if (item.scheduleCode) {
                let newItem = {}
                newItem.matchTime = item.formatTime
                newItem.matchName = `${item.disciplineName}·${item.scheduleName}`
                newItem.isChina = item.cn
                newItem.isGold = item.medalFlag === '1'
                newItem.type = item.confrontation
                  ? this.sportsTypeArr[0]
                  : this.sportsTypeArr[1]
                newItem.matchId = item.scheduleCode
                newItem.venueName = item.venueName
                this.matchStatusColorArr.forEach((statusItem) => {
                  let indexNo = statusItem.key.indexOf(res.data.schedule_status)
                  if (indexNo > -1) {
                    newItem.matchStatus = statusItem.name[indexNo]
                    this.currMatchStatus = statusItem
                  }
                })
                newItem.irm1Result = item.irm1Result
                newItem.irm2Result = item.irm2Result
                newItem.sportsId = item.disciplineCode
                newItem.sportsName = item.disciplineName
                newItem.eventId = item.eventCode
                newItem.eventName = item.eventName
                newItem.scheduleName = item.scheduleName
                newItem.formatDate = item.formatDate
                newItem.formatTime = item.formatTime
                newItem.competitor1Names = item.competitor1Names
                  ? item.competitor1Names.map((ceil) => {
                      return {
                        playerName: ceil.athleteName,
                        playerLogo: ceil.athleteLogo,
                      }
                    })
                  : []
                newItem.competitor2Names = item.competitor2Names
                  ? item.competitor2Names.map((ceil) => {
                      return {
                        playerName: ceil.athleteName,
                        playerLogo: ceil.athleteLogo,
                      }
                    })
                  : []
                newItem.competitorType = item.competitorType
                newItem.medalist = item.medals
                  ? item.medals.map((player, index) => {
                      return {
                        playerId: index + 1,
                        playerName: player.competitorName,
                        medalType: player.medalType,
                        delegationName: player.organisationName,
                        delegationLogo: player.organisationLogo,
                      }
                    })
                  : []

                if (newItem.type === this.sportsTypeArr[0]) {
                  let homeName = '',
                    awayName = ''
                  if (item.competitorType === 'T') {
                    homeName = item.organisation1Name
                    awayName = item.organisation2Name
                  }
                  newItem.homeName = homeName
                  newItem.awayName = awayName

                  newItem.homeScore = item.competitor1Result
                  newItem.awayScore = item.competitor2Result
                }
                newItem.homeLogo = item.organisation1Logo
                newItem.awayLogo = item.organisation2Logo
                newItem.annotation = item.annotation ? item.annotation : []
                newItem.currResultType = currResultType
                this.currMatchDetailInfor = newItem
                console.debug(
                  'this.currMatchDetailInfor:',
                  this.currMatchDetailInfor
                )
              } else {
                // this.currMatchDetailInfor = null
              }
            } else {
              console.debug('暂无数据')
              this.renderEventCompModeHanlde()
            }
          } else {
            this.renderEventCompModeHanlde()
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                duration: 0,
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
          this.renderEventCompModeHanlde()
        })

      if (
        this.currMatchStatus &&
        this.currMatchStatus.colorClass === 'playing'
      ) {
        // 比赛进行中 | 中场休息 开启刷新
        this.refreshSetTimeoutMatchData()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#sportsDetail_scheduleDetail {
  .shedule_date {
    margin-top: 2.778vw;
    width: 100%;
    height: calc(7.638vw + 4.158vw);
    .phaseTab {
      width: 100%;
      height: 4.158vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      .phaseItem {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: auto;
        min-width: 6.94vw;
        padding: 0 0.694vw;
        height: 2.778vw;
        font-size: 1.11vw;
        border-radius: 0.555vw;
        border: 1px solid var(--mixtmt_greyColor0);
        margin-right: 1.388vw;
        color: var(--mixtmt_greyColor2);
        &:last-child {
          margin: 0;
        }
        &.act {
          color: var(--mixtmt_whiteColor);
          background-color: var(--mixtmt_subColor1_1);
        }
      }
    }
  }

  .stringSocreExplain {
    width: 100%;
    height: auto;
    padding: 1.04vw 1.388vw;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    color: var(--mixtmt_greyColor2);
    .noteInfo_item {
      width: auto;
      min-width: 12.5%;
      padding-right: 1.388vw;
      text-align: left;
      font-size: 0.972vw;
      line-height: 1.11vw;
    }
  }
  .matchDetail_tab {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 3.47vw;
    padding: 0 1.388vw;
    background-color: var(--mixtmt_greyColor7);
    .matchResultTabItem {
      position: relative;
      width: auto;
      height: 3.47vw;
      line-height: 3.47vw;
      margin-right: 4.86vw;
      font-size: 1.25vw;
      font-weight: bold;
      color: var(--mixtmt_blackColor);
      &::before {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 2px;
        background-color: var(--mixtmt_subColor1_1);
      }
      &.act {
        color: var(--mixtmt_subColor1_1);
        &::before {
          content: '\20';
        }
      }
    }
  }

  .matchDetailDataContainer {
    width: 100%;
    min-height: 6.94vw;
  }
}

.mixtmt_pc #sportsDetail_scheduleDetail {
  .phaseTab {
    .phaseItem {
      &:hover {
        cursor: pointer;
        color: var(--mixtmt_whiteColor);
        background-color: var(--mixtmt_subColor1_1);
      }
    }
  }
  .matchDetail_tab {
    .matchResultTabItem {
      &:hover {
        cursor: pointer;
        color: var(--mixtmt_subColor1_1);
        &::before {
          content: '\20';
        }
      }
    }
  }
}
</style>
